/* eslint-disable react/prop-types */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { loginUsingPasswordWithPlanetFitness } from '../../store/ducks/user';
import styles from '../../shared-styles';
import pfLogo from './img/pf-logo-full.png';
import PFConnecting from '../../components/pf-connecting';

import './index.css';


export class PFLogin extends Component {
  state = {
    email: '',
    password: '',
    isPending: false
  }

  handleChangeEmail = (e) => {
    this.setState({ email: e.target.value });
  }

  handleChangePassword = (e) => {
    this.setState({ password: e.target.value });
  }

  submitForm = async () => {
    const { email, password } = this.state;
    try {
      this.setState({ isPending: true });
      const status = await this.props.login(email, password);
      const result = {
        ...status,
        planetFitnessLoginSuccess: true
      };

      this.props.handleSubmit(result);
    } catch (e) {
      this.setState({
        isPending: false,
        planetFitnessError: e.message
      });
    }
  }

  render() {
    if (this.state.isPending) {
      return <PFConnecting />;
    }

    return (
      <section className="pf-form">
        <div className="pf-form-container">
          <button
            className="close-button"
            onClick={ this.props.close }
          >x</button>
          <div className="login-box">
            <div className="login-content-box">
              <div className="login-header">
                <img
                  className="pf-logo"
                  src={ pfLogo }
                />
                <p>Please enter your Planet Fitness Mobile App credentials.</p>
              </div>
              { this.state.planetFitnessError
                ? <p className="error-text" style={ styles.errorStyle }>{ this.state.planetFitnessError }</p>
                : null
              }
              <div className="alert alert-danger" />
              <div className="form-group full-width-input">
                <span className="input-label">Email</span>
                <input type="email" className="form-control" onChange={ this.handleChangeEmail } />
              </div>
              <div className="form-group full-width-input">
                <span className="input-label">Password</span>
                <input type="password" className="form-control" onChange={ this.handleChangePassword } />
              </div>
            </div>
            <button
              type="submit"
              id="btn-login"
              className="btn-primary"
              onClick={ this.submitForm }
            >
              Log In
            </button>
            <p className="pf-reset">To create a Planet Fitness account or reset password, please go to the Planet Fitness Mobile App.</p>
          </div>
        </div>

      </section>
    );
  }
}

export default connect(
  null,
  dispatch => ({
    login: async (email, password) => await dispatch(loginUsingPasswordWithPlanetFitness({ email, password })),
  })
)(PFLogin);